/**
 * Visual Blocks Editor
 *
 * Copyright 2012 Google Inc.
 * http://blockly.googlecode.com/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Loop blocks for Blockly.
 * @author fraser@google.com (Neil Fraser)
 */
'use strict';

goog.provide('Blockly.Blocks.loops');

goog.require('Blockly.Blocks');

Blockly.Blocks.controls_repeat = {
  // Repeat n times (internal number).
  init: function() {
    this.setHelpUrl(Blockly.Msg.CONTROLS_REPEAT_HELPURL);
    this.setHSV(322, 0.9, 0.95);
    this.appendDummyInput()
      .appendTitle(Blockly.Msg.CONTROLS_REPEAT_TITLE_REPEAT)
      .appendTitle(
        new Blockly.FieldTextInput(
          '10',
          Blockly.FieldTextInput.nonnegativeIntegerValidator
        ),
        'TIMES'
      )
      .appendTitle(Blockly.Msg.CONTROLS_REPEAT_TITLE_TIMES);
    this.appendStatementInput('DO').appendTitle(
      Blockly.Msg.CONTROLS_REPEAT_INPUT_DO
    );
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.CONTROLS_REPEAT_TOOLTIP);
  }
};

Blockly.Blocks.controls_repeat_ext = {
  // Repeat n times (external number).
  init: function() {
    this.setHelpUrl(Blockly.Msg.CONTROLS_REPEAT_HELPURL);
    this.setHSV(322, 0.9, 0.95);
    this.interpolateMsg(
      Blockly.Msg.CONTROLS_REPEAT_TITLE,
      ['TIMES', 'Number', Blockly.ALIGN_RIGHT],
      Blockly.ALIGN_RIGHT
    );
    this.appendStatementInput('DO').appendTitle(
      Blockly.Msg.CONTROLS_REPEAT_INPUT_DO
    );
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.CONTROLS_REPEAT_TOOLTIP);
  }
};

Blockly.Blocks.controls_whileUntil = {
  // Do while/until loop.
  init: function() {
    var OPERATORS = [
      [Blockly.Msg.CONTROLS_WHILEUNTIL_OPERATOR_WHILE, 'WHILE'],
      [Blockly.Msg.CONTROLS_WHILEUNTIL_OPERATOR_UNTIL, 'UNTIL']
    ];
    this.setHelpUrl(Blockly.Msg.CONTROLS_WHILEUNTIL_HELPURL);
    this.setHSV(322, 0.9, 0.95);
    this.appendValueInput('BOOL')
      .setCheck(Blockly.BlockValueType.BOOLEAN)
      .appendTitle(new Blockly.FieldDropdown(OPERATORS), 'MODE');
    this.appendStatementInput('DO').appendTitle(
      Blockly.Msg.CONTROLS_WHILEUNTIL_INPUT_DO
    );
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    // Assign 'this' to a variable for use in the tooltip closure below.
    var thisBlock = this;
    this.setTooltip(function() {
      var op = thisBlock.getTitleValue('MODE');
      var TOOLTIPS = {
        WHILE: Blockly.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_WHILE,
        UNTIL: Blockly.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL
      };
      return TOOLTIPS[op];
    });
  }
};

Blockly.Blocks.controls_for = {
  // For loop.
  init: function() {
    this.setHelpUrl(Blockly.Msg.CONTROLS_FOR_HELPURL);
    this.setHSV(322, 0.9, 0.95);
    this.interpolateMsg(
      Blockly.Msg.CONTROLS_FOR_INPUT_COUNTER,
      goog.bind(function() {
        this.appendDummyInput().appendTitle(
          new Blockly.FieldVariable(null),
          'VAR'
        );
      }, this),
      ['FROM', 'Number', Blockly.Msg.ALIGN_RIGHT],
      ['TO', 'Number', Blockly.Msg.ALIGN_RIGHT],
      ['BY', 'Number', Blockly.Msg.ALIGN_RIGHT],
      Blockly.Msg.ALIGN_RIGHT
    );
    this.appendStatementInput('DO').appendTitle(
      Blockly.Msg.CONTROLS_FOR_INPUT_DO
    );
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setInputsInline(true);
    // Assign 'this' to a variable for use in the tooltip closure below.
    var thisBlock = this;
    this.setTooltip(function() {
      return Blockly.Msg.CONTROLS_FOR_TOOLTIP.replace(
        '%1',
        thisBlock.getTitleValue('VAR')
      );
    });
  },
  getVars: Blockly.Variables.getVars,
  renameVar: function(oldName, newName) {
    if (Blockly.Names.equals(oldName, this.getTitleValue('VAR'))) {
      this.setTitleValue(newName, 'VAR');
    }
  },
  customContextMenu: function(options) {
    var option = {enabled: true};
    var name = this.getTitleValue('VAR');
    option.text = Blockly.Msg.VARIABLES_SET_CREATE_GET.replace('%1', name);
    var xmlTitle = goog.dom.createDom('title', null, name);
    xmlTitle.setAttribute('name', 'VAR');
    var xmlBlock = goog.dom.createDom('block', null, xmlTitle);
    xmlBlock.setAttribute('type', 'variables_get');
    option.callback = Blockly.ContextMenu.callbackFactory(this, xmlBlock);
    options.push(option);
  },
  domToMutation: function(xmlElement) {
    if (xmlElement.getAttribute('name') === 'default_var') {
      var baseName = xmlElement.childNodes[0].data;
      var newName = Blockly.Variables.generateUniqueNameFromBase_(baseName);
      this.setTitleValue(newName, 'VAR');
    }
  }
};

Blockly.Blocks.controls_forEach = {
  // For each loop.
  init: function() {
    this.setHelpUrl(Blockly.Msg.CONTROLS_FOREACH_HELPURL);
    this.setHSV(322, 0.9, 0.95);
    this.appendValueInput('LIST')
      .setCheck(Blockly.BlockValueType.ARRAY)
      .appendTitle(Blockly.Msg.CONTROLS_FOREACH_INPUT_ITEM)
      .appendTitle(new Blockly.FieldVariable(null), 'VAR')
      .appendTitle(Blockly.Msg.CONTROLS_FOREACH_INPUT_INLIST);
    if (Blockly.Msg.CONTROLS_FOREACH_INPUT_INLIST_TAIL) {
      this.appendDummyInput().appendTitle(
        Blockly.Msg.CONTROLS_FOREACH_INPUT_INLIST_TAIL
      );
      this.setInputsInline(true);
    }
    this.appendStatementInput('DO').appendTitle(
      Blockly.Msg.CONTROLS_FOREACH_INPUT_DO
    );
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    // Assign 'this' to a variable for use in the tooltip closure below.
    var thisBlock = this;
    this.setTooltip(function() {
      return Blockly.Msg.CONTROLS_FOREACH_TOOLTIP.replace(
        '%1',
        thisBlock.getTitleValue('VAR')
      );
    });
  },
  getVars: Blockly.Variables.getVars,
  renameVar: function(oldName, newName) {
    if (Blockly.Names.equals(oldName, this.getTitleValue('VAR'))) {
      this.setTitleValue(newName, 'VAR');
    }
  },
  customContextMenu: Blockly.Blocks.controls_for.customContextMenu
};

Blockly.Blocks.controls_flow_statements = {
  // Flow statements: continue, break.
  init: function() {
    var OPERATORS = [
      [Blockly.Msg.CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK, 'BREAK'],
      [Blockly.Msg.CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE, 'CONTINUE']
    ];
    this.setHelpUrl(Blockly.Msg.CONTROLS_FLOW_STATEMENTS_HELPURL);
    this.setHSV(322, 0.9, 0.95);
    this.appendDummyInput().appendTitle(
      new Blockly.FieldDropdown(OPERATORS),
      'FLOW'
    );
    this.setPreviousStatement(true);
    // Assign 'this' to a variable for use in the tooltip closure below.
    var thisBlock = this;
    this.setTooltip(function() {
      var op = thisBlock.getTitleValue('FLOW');
      var TOOLTIPS = {
        BREAK: Blockly.Msg.CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK,
        CONTINUE: Blockly.Msg.CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE
      };
      return TOOLTIPS[op];
    });
  },
  onchange: function() {
    if (!this.blockSpace) {
      // Block has been deleted.
      return;
    }
    var legal = false;
    // Is the block nested in a control statement?
    var block = this;
    do {
      if (
        block.type == 'controls_repeat' ||
        block.type == 'controls_repeat_ext' ||
        block.type == 'controls_forEach' ||
        block.type == 'controls_for' ||
        block.type == 'controls_whileUntil'
      ) {
        legal = true;
        break;
      }
      block = block.getSurroundParent();
    } while (block);
    if (legal) {
      this.setWarningText(null);
    } else {
      this.setWarningText(Blockly.Msg.CONTROLS_FLOW_STATEMENTS_WARNING);
    }
  }
};
